import React from "react";
import * as Icons from "lucide-react";
import { StatCard } from "@/components/common/StatCard";
import { CELL } from "@/lib/people";

const COLS = [["open", "Open"], ["overdue", "Overdue"], ["blocked", "Blocked"], ["awaiting_review", "Review"], ["completed_week", "Done (7 days)"], ["kpi_missing", "KPIs missed"]];

function Today({ p }) {
  const c = p.today;
  const meta = c ? CELL[c.state] || CELL.unknown : null;
  const label = !c ? null : ["off", "part"].includes(c.state) ? `${c.state === "part" ? "Part day · " : ""}${c.label}` : meta.label;
  return (
    <div className="flex items-center gap-1.5" data-testid={`today-${p.user_id}`}>
      {c && <span className={`rounded px-1.5 py-0.5 text-[11px] font-medium ${["off", "part"].includes(c.state) ? "bg-[#4A78A8]/10 text-[#4A78A8]" : meta.cls}`}>{label}{c.pending ? " (pending)" : ""}</span>}
      {p.clocked_in && <span className="flex items-center gap-1 text-[11px] text-[#3D8B65]"><span className="h-1.5 w-1.5 rounded-full bg-[#3D8B65]" />Clocked in</span>}
    </div>
  );
}

export function TeamOverviewTab({ data, onOpenPerson }) {
  const t = data.totals;
  const showToday = data.leave_on || data.clocking_on;
  return (
    <div data-testid="team-overview">
      <div className="mb-6 grid grid-cols-2 gap-3 md:grid-cols-3 xl:grid-cols-6">
        <StatCard icon="ListTodo" label="Open work" value={t.open} testId="team-stat-open" />
        <StatCard icon="AlarmClock" label="Overdue" value={t.overdue} tone={t.overdue ? "red" : "green"} testId="team-stat-overdue" />
        <StatCard icon="OctagonAlert" label="Blocked" value={t.blocked} tone={t.blocked ? "red" : "green"} testId="team-stat-blocked" />
        <StatCard icon="ShieldCheck" label="Awaiting review" value={t.awaiting_review} tone="amber" testId="team-stat-review" />
        <StatCard icon="CircleCheck" label="Done in 7 days" value={t.completed_week} tone="green" testId="team-stat-done" />
        <StatCard icon="Gauge" label="KPI periods missed" value={t.kpi_missing} tone={t.kpi_missing ? "amber" : "green"} testId="team-stat-kpi-missing" />
      </div>
      {data.pending_invitations > 0 && (
        <p className="mb-4 flex items-center gap-1.5 text-sm text-[#4A78A8]" data-testid="team-pending-invites">
          <Icons.MailCheck size={15} /> {data.pending_invitations} invitation{data.pending_invitations === 1 ? " is" : "s are"} waiting to be accepted.
        </p>
      )}
      <div className="amden-card overflow-hidden p-0">
        <div className="overflow-x-auto">
          <table className="w-full min-w-[640px] text-sm" data-testid="team-people-table">
            <thead>
              <tr className="border-b border-[#E4E8EF] text-left text-xs uppercase tracking-wide text-[#1E2D44]/45">
                <th className="px-5 py-3 font-semibold">Person</th>
                {showToday && <th className="px-3 py-3 font-semibold">Today</th>}
                {COLS.map(([k, l]) => <th key={k} className="px-3 py-3 text-center font-semibold">{l}</th>)}
                <th className="px-3 py-3" />
              </tr>
            </thead>
            <tbody>
              {data.people.map((p) => (
                <tr key={p.user_id} onClick={() => onOpenPerson(p.user_id)} className="cursor-pointer border-b border-[#EEF1F6] transition-colors hover:bg-[#F7F9FC]" data-testid={`team-person-${p.user_id}`}>
                  <td className="px-5 py-3">
                    <div className="font-medium text-[#0B1729]">{p.name}</div>
                    <div className="text-xs text-[#1E2D44]/50">{[p.title, p.department].filter(Boolean).join(" · ") || p.role_label}</div>
                  </td>
                  {showToday && <td className="px-3 py-3"><Today p={p} /></td>}
                  {COLS.map(([k]) => (
                    <td key={k} className={`px-3 py-3 text-center font-semibold ${p[k] && ["overdue", "blocked", "kpi_missing"].includes(k) ? "text-[#C95555]" : "text-[#0B1729]"}`}>{p[k]}</td>
                  ))}
                  <td className="px-3 py-3 text-right text-[#1E2D44]/30"><Icons.ChevronRight size={16} /></td>
                </tr>
              ))}
              {data.people.length === 0 && <tr><td colSpan={9} className="p-8 text-center text-sm text-[#1E2D44]/45">No one in your team yet.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
